import React, { useState } from "react";
import LikesModal from "./LikesModal";
import CommentsModal from "./CommentsModal";
import ShareModal from "./ShareModal";
import { formatCount } from "../Helpers/utils";
import { useGlobalState } from "../contexts/GlobalStateContext";

const PostFooter = ({ post }) => {
  const [showLikesModal, setShowLikesModal] = useState(false);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
    const [selectedUuid, setSelectedUuid] = useState(null);

  const { globalState, addLike, removeLike, setShowLogins, logOut, resetGlobalState } = useGlobalState();
  const { likes, isAuthenticated } = globalState;

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const isLiked = Array.isArray(likes) && likes.includes(post.uuid);

  const [commentCount, setCommentCount] = useState(post.comments); 

  const handleCommentCountChange = (newCount) => {
    setCommentCount(newCount);
  };

  const handleLikesClick = (post) => {
    setSelectedPost(post);
    setShowLikesModal(true);
  };

  const handleCommentsClick = (post) => {
    setSelectedPost(post);
    setShowCommentsModal(true);
  };

  const toggleLike = () => {
    if (!isAuthenticated) {
      setShowLogins(true);
      return;
    }

    const action = isLiked ? "unlike" : "like";
    const payload = { uuid: post.uuid, action };

    fetch(`${baseUrl}/php/toggle_like.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          if (action === "like") {
            addLike(post.uuid);
            post.likes += 1;
          } else {
            removeLike(post.uuid);
            post.likes = Math.max(post.likes - 1, 0);
          }
        } else if (data.status === "error"){
          logOut();
          resetGlobalState();
        } else {
          console.error("Failed to toggle like:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error during like toggle:", error);
      });
  };

  if (post.draft) return null;

  return (
    <>
      <div style={{ color: post.text_bg, backgroundColor: post.theme }}
        className="bottom-left"
        id={`${post.uuid}-like-toggle`}
        onClick={toggleLike}
      >
        {isLiked ? "Unlike" : "Like"}
      </div>
      <div className="footer">
        <span
          id={`${post.uuid}-likes`}
          style={{ cursor: "pointer", marginRight: "4px" }}
          onClick={() => handleLikesClick(post)}
        >
          {formatCount(post.likes)} {post.likes == 1 ? "Like" : "Likes"} 
        </span>
        | <span
          id={`${post.uuid}-comments`}
          style={{ cursor: "pointer" }}
          onClick={() => handleCommentsClick(post)}
        >
          {formatCount(commentCount)}{" "}
          {commentCount == 1 ? "Comment" : "Comments"}
        </span>
      </div>

       <div className="bottom-right" style={{ color: post.text_bg, backgroundColor: post.theme, cursor: "pointer" }}>
              <span
                id="s"
                alt="Share"
                onClick={() => setSelectedUuid(post.uuid)}
              >
                Share
              </span>
            </div>

      {/* Modals */}
      {showLikesModal && selectedPost && (
        <LikesModal
          post={selectedPost}
          onClose={() => setShowLikesModal(false)}
        />
      )}
      {showCommentsModal && selectedPost && (
        <CommentsModal
          post={selectedPost}
          noOfComments={commentCount}
          onCommentCountChange={handleCommentCountChange}
          onClose={() => setShowCommentsModal(false)}
        />
      )}
              {selectedUuid && <ShareModal onClose={() => setSelectedUuid(null)} />}
    </>
  );
};

export default PostFooter;
